/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import {
  Form,
  FormGroup,
  Col,
} from 'react-bootstrap';
import RichButton from 'loracoms/RichButton';
import FormBlock from 'loracoms/FormBlock';
import IntlMsg from 'lorautils/intl/IntlMsg';
import ErrorSet from 'lorautils/errors/ErrorSet';
import deviceActions from 'loraactions/device';


const propTypes = {
  sent: React.PropTypes.object.isRequired,
  intl: React.PropTypes.any.isRequired,
  deviceId: React.PropTypes.string.isRequired,
  sendCmd: React.PropTypes.func.isRequired,
  getTxSize: React.PropTypes.func.isRequired,
  getMacLog: React.PropTypes.func.isRequired,
};

class DevStatusReq extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: new ErrorSet(),
    };
    this.intlMsg = new IntlMsg(props.intl, 'devicedetail.macview');
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { sent } = nextProps;
    let { errors } = this.state;

    if (sent !== this.props.sent) {
      this.setState({ sentStatus: sent.status });
      if (sent.status === 'failure') {
        errors = errors.add(sent.error.code, 'submit');
        this.setState({ errors });
      }
      if (sent.status === 'success') {
        const { getTxSize, getMacLog, deviceId } = nextProps;
        getTxSize(deviceId);
        getMacLog(deviceId);
      }
    }
  }

  handleSubmit(e) {
    e.preventDefault();

    const { errors } = this.state;
    if (!errors.isEmpty()) {
      return;
    }

    const { deviceId, sendCmd } = this.props;
    const { maxdc } = this.state;
    sendCmd(deviceId, { maxdc });
  }

  render() {
    const {
      sentStatus = '',
      errors,
    } = this.state;

    return (
      <Form horizontal onSubmit={this.handleSubmit}>
        <FormGroup>
          <Col mdOffset={3} md={6}>
            <RichButton
              status={sentStatus}
              states={[{
                status: 'default',
                label: this.intlMsg.msg('submit'),
                style: 'primary',
                type: 'submit',
              }, {
                status: 'success',
                label: this.intlMsg.msg('submit.success'),
                style: 'success',
                timer: () => this.setState({ sentStatus: '' }),
              }, {
                status: 'failure',
                label: this.intlMsg.msg('submit.failure'),
                style: 'danger',
                timer: () => this.setState({ sentStatus: '' }),
              }]}
            />
          </Col>
        </FormGroup>
        <FormGroup>
          <Col mdOffset={3} md={6}>
            <FormBlock
              show={errors.has('submit')}
              message={this.intlMsg.errorMsg(errors.get('submit'))}
              azStyle="danger"
            />
          </Col>
        </FormGroup>
      </Form>
    );
  }
}

DevStatusReq.propTypes = propTypes;

const mapStateToProps = state => ({
  sent: state.device.sendDevStatusReq,
});

const mapDispatchToProps = {
  sendCmd: deviceActions.sendDevStatusReq,
  getTxSize: deviceActions.getMacTxSize,
  getMacLog: deviceActions.getMacLog,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(DevStatusReq));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/DeviceDetail/coms/MacView/coms/DevStatusReq.jsx